// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ozBx","bigColWidth":"Table_bigColWidth__1m1a7","biggerColWidth":"Table_biggerColWidth__3ox8N","row":"Table_row__3Pz2D","col":"Table_col__3mqJv"};